var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"none-data align jus"},[_c('img',{attrs:{"src":require("../static/images/none-data-2.png"),"alt":"empty"}}),_vm._v("\n  "+_vm._s(_vm.props.tips)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }